import React from 'react';
import { motion } from 'framer-motion';
import { Thermometer, Brain, Moon } from 'lucide-react';
export function SolutionSection() {
  const layers = [{
    icon: Thermometer,
    title: '1. Cierre Térmico',
    desc: 'Cuando el cuerpo está caliente / sudando',
    color: 'text-orange-300'
  }, {
    icon: Brain,
    title: '2. Cierre Mental',
    desc: 'Cuando la mente arranca con rumiación',
    color: 'text-blue-300'
  }, {
    icon: Moon,
    title: '3. Cierre Corporal',
    desc: 'Rutina corta para volver al sueño',
    color: 'text-purple-300'
  }];
  return <section className="w-full py-20 md:py-32 px-6 bg-navy-light border-y border-navy-lighter relative" data-id="element-124">
      <div className="max-w-5xl mx-auto" data-id="element-125">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-126">
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-cream mb-4" data-id="element-127">
            PRESENTANDO: <span className="text-gold" data-id="element-128">EL PROTOCOLO 3AM</span>
          </h2>
          <p className="text-xl md:text-2xl text-cream-muted max-w-3xl mx-auto" data-id="element-129">
            Corta el Despertar de 3–4AM y Vuelve a Dormir en Minutos
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-130">
          {layers.map((layer, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2,
          duration: 0.6
        }} className="bg-navy p-8 rounded-xl border border-gold/20 shadow-lg flex flex-col items-center text-center hover:border-gold/40 transition-colors duration-300" data-id="element-131">
              <div className="w-16 h-16 rounded-full bg-navy-light border border-navy-lighter flex items-center justify-center mb-6 shadow-[0_0_15px_rgba(0,0,0,0.3)]" data-id="element-132">
                <layer.icon className={`w-8 h-8 ${layer.color}`} data-id="element-133" />
              </div>
              <h3 className="font-serif text-2xl font-bold text-cream mb-3" data-id="element-134">
                {layer.title}
              </h3>
              <p className="text-cream-muted text-lg" data-id="element-135">{layer.desc}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6,
        duration: 0.8
      }} className="text-center max-w-2xl mx-auto" data-id="element-136">
          <p className="text-xl md:text-2xl text-cream font-serif italic" data-id="element-137">
            «No haces ‹mil cosas›. Haces la secuencia correcta.»
          </p>
          <div className="mt-8 text-lg text-cream-muted" data-id="element-138">
            <p className="mb-4" data-id="element-139">No es un libro largo para leer «algún día».</p>
            <p data-id="element-140">Es una guía práctica para ejecutar la misma noche.</p>
          </div>
        </motion.div>
      </div>
    </section>;
}